module.exports = {
  // General
  'About {appName}': 'Om {appName}',
  'About Enable Banking API': 'Om Enable Banking API',
  'Application description is not provided.': 'Applikationsbeskrivning tillhandahålls inte.',
  'Authenticate': 'Autentisera',
  'Authentication method': 'Autentiseringsmetod',
  'Authentication session has expired': 'Autentiseringssessionen har löpt ut',
  'Cancel': 'Avbryt',
  'Click {0} button if you have confirmed authorization in the BankID app.': 'Klicka på knappen {0} om du har bekräftat auktorisationen i BankID-appen.',
  'Continue authentication': 'Fortsätt autentisering',
  'Cookies must be enabled in your browser to continue': 'Cookies måste vara aktiverade i din webbläsare för att fortsätta',
  'Enter your OTP code with index {0}': 'Ange din OTP-kod med index {0}',
  'Error during authentication:': 'Fel vid autentisering:',
  'Error while updating authentication status': 'Fel vid uppdatering av autentiseringsstatus',
  'Open the BankID app on this device': 'Öppna BankID-appen på den här enheten',
  'OTP code': 'OTP-kod',
  'Redirecting to your account servicing provider': 'Omdirigerar till din kontoserviceleverantör',
  'Returning to the authentication initiator': 'Återgår till autentiseringsinitiatören',
  'Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page': 'Starta BankID-appen på din mobila enhet och tryck på QR-kodknappen i appen för att skanna QR-koden på den här sidan',
  'or': 'eller',
  'Starting authorization': 'Startar auktorisering',
  'To continue please use your authentication app': 'Använd din autentiseringsapp för att fortsätta',
  'Try again': 'Försök igen',
  'Submit': 'Skicka',
  'Unable to access server': 'Det går inte att komma åt servern',
  'Unable to authenticate': 'Det gick inte att autentisera',
  'Unable to continue authorization': 'Det gick inte att fortsätta auktoriseringen',
  'Unable to continue decoupled authorization': 'Det gick inte att fortsätta frikopplad auktorisering',
  'Unable to handle authentication status "{status}"': 'Det går inte att hantera autentiseringsstatus "{status}"',
  'Unknown error occurred': 'Okänt fel har inträffat',
  'You need to close this window': 'Du måste stänga det här fönstret',
  'Authentication cancelled': 'Autentiseringen avbröts',
  // Consent
  'Authentication is initiated by {0}.': 'Autentisering initieras av {0}.',
  'After you complete authentication, {0} will be shared with the authentication initiator.': 'Efter att du har slutfört identifieringsprocessen kommer {0} att vara tillgängliga för organisationen som påbörjat autentiseringsprocessen.',
  'your payment accounts data': 'dina betalningskontouppgifter',
  'the list of your payment accounts': 'listan över dina betalkonton',
  'the list of your payment accounts and accounts balances': 'listan över dina betalkonton och kontosaldon',
  'the list of your payment accounts and accounts transactions': 'listan över dina betalkonton och kontotransaktioner',
  'the list of your payment accounts, accounts balances and transactions': 'listan över dina betalkonton, kontosaldon och transaktioner',
  'By pressing {0} button you agree with the {1}.': 'Genom att trycka {0} godkänner du {1}.',
  'Press {0} button if you are not willing to share your payment accounts data.': 'Tryck {0} om du inte går med på att dela dina betalningsuppgifter.',
  // Payment consent
  'Payment details': 'Betalningsinformation',
  'Payment ID provided by the application: {0}': 'Betalnings-ID som tillhandahålls av applikationen: {0}',
  'Account number where to transfer funds: {0}': 'Kontonummer dit du kan överföra pengar: {0}',
  'Payee name in the payment: {0}': 'Betalningsmottagarens namn i betalningen: {0}',
  'Payee country: {0}': 'Betalningsmottagarens land: {0}',
  'Payment amount: {0}': 'Betalningsbelopp: {0}',
  'Message or reference number in the payment: {0}': 'Meddelande eller referensnummer i betalningen: {0}',
  'Payment is initiated by {0}.': 'Betalning initieras av {0}.',
  'After you complete authentication, your payment consent will be requested by your account servicing payment service provider.': 'När du har slutfört autentiseringen kommer ditt betalningssamtycke att begäras av din kontoförmedlande betaltjänstleverantör.',
  'terms of service': 'användarvillkor',
  'Press {0} button if you are not willing to complete this payment.': 'Tryck på knappen {0} om du inte är villig att slutföra den här betalningen.',
  'Select Payment Account': 'Välj betalkonto',
  'Confirm': 'Bekräfta',
  // Backend messages
  '10 digit client number': '10-siffrigt kundnummer',
  '10 digit organisation number (or 12 digit personal number if the company is a sole proprietorship)': '10-siffrigt organisationsnummer (eller 12-siffrigt personnummer om företaget är en enskild firma)',
  '10 digit organization number.': '10-siffrigt organisationsnummer.',
  '17 digit card number (starting with 6703)': '17-siffrigt kortnummer (börjar med 6703)',
  '6 digit Handelsbanken customer number': '6-siffrigt Handelsbankens kundnummer',
  '8 digits CVR number': '8-siffrigt CVR-nummer',
  '9 digits Organisasjonsnummer': '9 siffror Organisationsnummer',
  'Agreement number': 'Avtalsnummer',
  'Agreement number for Nordea Corporate Netbank': 'Nordea Corporate Netbank avtalsnummer',
  'Bank user ID': 'Bank användar-ID',
  'Business identity code (Y-tunnus) in 1234567-8 format': 'Företagsidentitetskod (Y-tunnus) i 1234567-8-format',
  'Business identity code which is displayed in the Corporate Internet bank settings': 'Affärsidentitetskod som visas i företagets internetbankinställningar',
  'Client ID': 'Klient ID',
  'Client number': 'Klient nummer',
  'Company ID': 'Företags ID',
  'Company number': 'Företagsnummer',
  'Corporate ID': 'Företags-ID',
  'Corporate registration ID': 'Företagsregistrerings-ID',
  'Currency code': 'Valutakod',
  'Digit card number': 'Sifferkortsnummer',
  'Disposer': 'Avfallshanterare',
  'E-mail': 'E-post',
  'E-mail used for authenticating to Holvi': 'E-post som används för autentisering till Holvi',
  'Either the 14 digit SEB identifier for the company or the 10 digit organization number': 'Antingen den 14-siffriga SEB-identifieraren för företaget eller det 10-siffriga organisationsnumret',
  'FKDN (without subaccount number): 3 digit branch number + 7 digit customer number': 'FKDN (utan underkontonummer): 3-siffrigt kontorsnummer + 7-siffrigt kundnummer',
  'For Swedish Corporates, this is their Organisation number or SHB number, and for Sole Traders (Enskild firma), it is their Personal number, all of which are 10 digits.': 'För Svenska företag är detta deras organisationsnummer eller SHB-nummer, och för Enskild firma är det deras personnummer, som alla är 10 siffror.',
  'IBAN': 'IBAN',
  'ID, NIE, Passport': 'ID, NIE, pass',
  'Login ID used in MyBRD aplications': 'Inloggnings-ID som används i MyBRD-applikationer',
  'Login Name': 'Inloggningsnamn',
  'Mandate ID': 'Fullmakts-ID',
  'Norwegian national identity number in the format DDMMYYXXXXX (11 digits)': 'Norskt personnummer i formatet DDMMYYXXXXXX (11 siffror)',
  'Online banking PIN': 'PIN-kod för internetbank',
  'Online banking Password': 'Lösenord för internetbank',
  'Organisation ID in the format TBxxxxx or TXxxxxx': 'Organisations-ID i formatet TBxxxxx eller TXxxxxx',
  'Organisation number': 'Organisationsnummer',
  'PIN': 'PIN',
  'Password': 'Lösenord',
  'Password for Aktia Internet bank': 'Lösenord för Aktia Internetbank',
  'Password used for authenticating to Holvi': 'Lösenord används för autentisering till Holvi',
  'Personal ID': 'Personligt ID',
  'Personal ID number': 'Personnummer',
  'Personal code': 'Personlig kod',
  'Personal code of the user': 'Användarens personliga kod',
  'Personal signatory number': 'Personligt firmatecknarnummer',
  'Personal username for online banking': 'Personligt användarnamn för internetbank',
  'Postbank ID': 'Postbank ID',
  'Social security number (Personnummer)': 'Personnummer (personnummer)',
  'Social security number in the format YYYYMMDDXXXX': 'Personnummer i formatet ÅÅÅÅMMDDXXXX',
  'Swedish social security number in the format YYYYMMDDXXXX': 'Svenskt personnummer i formatet ÅÅÅÅMMDDXXXX',
  'The IBAN of the user authenticating': 'IBAN för användaren som autentiserar',
  'The currency code': 'Valutakoden',
  'The user ID of the user authenticating': 'Användar-ID för användaren som autentiserar',
  'Unique personal ID number': 'Unikt personnummer',
  'User ID': 'Användar ID',
  'User ID for Aktia Internet bank': 'Användar-ID för Aktia Internetbank',
  'User ID for Nordea Corporate Netbank': 'Användar-ID för Nordea Corporate Netbank',
  'User ID for online banking': 'Användar-ID för internetbank',
  'User ID in the format XX000000': 'Användar-ID i formatet XX000000',
  'User ID used to log in to the bank': 'Användar-ID som används för att logga in på banken',
  'Username': 'Användarnamn',
  'Username used to log in to the bank': 'Användarnamn som används för att logga in på banken',
  'VR NetKey': 'VR NetKey',
  'WebSSO user name': 'WebSSO användarnamn',
}
